export const locale = {
	lang: 'fr',
	data: {
		HEADER: {
			'LOGIN': 'Se connecter',
			'APPLICATION': 'Apps',
			'PROFILE': 'Profil',
			'SETTINGS': 'ParamÃ¨tres',
			'LOGOUT': 'DÃ©connexion',
			'SEARCH': 'Rechercher',
		},
		FOOTER: {
			'ALL_RIGHTS_RESERVED': 'Tous droits rÃ©servÃ©s',
		},
		NOTIFICATION: {
			SUCCESS: 'SuccÃ¨s',
			INFO: 'Information',
			WARNING: 'Avertissement',
			ERROR: 'Erreur'
		},
		CONFIRM_DIALOG: {
			CONFIRMATION: 'Confirmation',
			CONFIRM: 'Confirmer',
			CANCEL: 'Annuler'
		},
		CUSTOMER_TREE_TYPE: {
			UNDEF: 'Non dÃ©fini',
			RESORT: 'Station',
			SECTOR: 'Secteur',
			ZONE: 'Zone mÃ©tÃ©o'
		},
		CONFIRM_UNSAVED_CHANGES: 'Vous n\'avez pas enregistrÃ© vos changements, voulez-vous continuer ?' ,
		ERROR: 'Une erreur est survenue!',
		POST_PUT_USER_CONFLICT: 'Il existe dÃ©jÃ  un utilisateur avec cette adresse mail',
		GET_APPS_ERROR: 'Une erreur est survenue lors de la rÃ©cupÃ©ration des applications!',
		GET_CUSTOMER_TREE_ERROR: 'Une erreur est survenue lors de la rÃ©cupÃ©ration de l\'arborescence client!',
		GET_USERS_ERROR: 'Une erreur est survenue lors de la rÃ©cupÃ©ration des utilisateurs!',
		GET_USER_ACCESS_ERROR: 'Une erreur est survenue lors de la rÃ©cupÃ©ration des droits utilisateur!',
		GET_USER_APPLICATIONS_ERROR: 'Une erreur est survenue lors de la rÃ©cupÃ©ration des applications utilisateur!'
	}
};
